/**
 * Uploads a payment receipt PDF to Storage and returns the public URL.
 * Path must match RLS `empresa_assets_authenticated_insert`:
 *   facturas/{empresaId}/comprobantes/{facturaId}/...
 */
import { supabase } from '../lib/supabase';

const BUCKET = 'empresa-assets';

/** Historial/saldo placeholders are not rows in `pagos_cobro`. */
export function isSyntheticPagoId(pagoId?: string | null): boolean {
  const id = String(pagoId || '');
  return !id || id.startsWith('hist-') || id.startsWith('saldo-');
}

/** Stable, unique path segment so two abonos on the same cobro do not overwrite. */
export function reciboStorageFileId(pagoId: string): string {
  const raw = String(pagoId || 'pago')
    .replace(/[^a-zA-Z0-9._-]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
  return (raw || 'pago').slice(0, 96);
}

export function reciboStoragePath(
  empresaId: string,
  facturaId: string,
  pagoId: string,
  reciboNumero: string
): string {
  const clean = String(reciboNumero || 'recibo')
    .replace(/[^a-zA-Z0-9._-]/g, '_')
    .slice(0, 80);
  return `facturas/${empresaId}/comprobantes/${facturaId}/recibo-${reciboStorageFileId(pagoId)}-${clean}.pdf`;
}

export async function uploadReciboPagoPdfPublicLink(
  blob: Blob,
  empresaId: string,
  facturaId: string,
  pagoId: string,
  reciboNumero: string
): Promise<string | null> {
  if (!empresaId?.trim() || !facturaId?.trim() || !pagoId?.trim()) return null;

  // Must match storage policy: facturas/{empresaUuid}/comprobantes/{...}
  const path = reciboStoragePath(empresaId, facturaId, pagoId, reciboNumero);

  const { data, error } = await supabase.storage.from(BUCKET).upload(path, blob, {
    contentType: 'application/pdf',
    cacheControl: '120',
    upsert: true,
  });

  if (error) {
    console.warn('[uploadReciboPagoPdfPublicLink]', error.message);
    return null;
  }

  const { data: pub } = supabase.storage.from(BUCKET).getPublicUrl(data.path);
  return pub?.publicUrl ?? null;
}
